// Components
import { SidebarMenuMobile } from './sidebar-mobile';
// Contexto de AuthProvider
import { useContext } from 'react';
import { AuthContext } from '@/features/auth/Context/AuthContext';
// Store Data
import { useAppSelector } from '@/hooks/use-state';
import {  selectAuthLoading, selectUser, selectUserGroup } from "@/features/auth/authSlice";
import { SidebarProps } from './sidebar.interface';
import { Sheet, SheetContent } from '@/components/ui/sheet';

export function Sidebar({ isMobileOpen, toggleSidebar }: SidebarProps) {
  const user = useAppSelector(selectUser);
  const userGroup = useAppSelector(selectUserGroup);
  const isLoadingUser = useAppSelector(selectAuthLoading);
  const auth = useContext(AuthContext);
  if (!auth) throw new Error("AuthContext not found. Did you forget to wrap your app with <AuthProvider />?");
  const { logout } = auth;
  
  if(isLoadingUser) return null;
  
  if (!user) return null;

  const handleLogout = async () => {
    await logout();
  };
  
  return (
    <Sheet open={isMobileOpen} onOpenChange={toggleSidebar}>
      <SheetContent 
        side="left"
        className="p-0 bg-[#0F172A] text-white border-r-0 w-[280px]"
      >
        <SidebarMenuMobile 
          user={user}
          userGroup={userGroup}
          handleLogout={handleLogout}
          onNavigate={() => toggleSidebar()}
        />
      </SheetContent>
    </Sheet>
  );
}